"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var react_inlinesvg_1 = require("react-inlinesvg");

exports.iconStyle = function (width, height, fill, disabled) {
  return hs_web_style_guide_1.css({
    width: width,
    height: height,
    ' span': {
      width: width,
      height: height,
      display: 'inline-block'
    },
    ' svg': fill ? {
      width: width,
      height: height,
      fill: fill,
      opacity: disabled ? 0.5 : 1
    } : {
      width: width,
      height: height
    }
  });
};

function Icon(props) {
  var width = props.width,
      height = props.height,
      fill = props.fill,
      src = props.src,
      ariaLabel = props.ariaLabel,
      disabled = props.disabled;

  if (ariaLabel) {
    return React.createElement("div", {
      className: "" + exports.iconStyle(width, height, fill, disabled),
      "aria-label": ariaLabel
    }, React.createElement(react_inlinesvg_1.default, {
      src: src
    }));
  }

  return React.createElement("div", {
    className: "" + exports.iconStyle(width, height, fill, disabled),
    "aria-disabled": "true"
  }, React.createElement(react_inlinesvg_1.default, {
    src: src
  }));
}

exports.Icon = Icon;